<ng-container *ngIf="blog; else noBlog">
  <uni-json-ld-schema [itemLD]="articleSchema"></uni-json-ld-schema>
  <div class="blog-card" *ngIf="!featured" #blogCardContainer>
    <div [class]="(cardWidth <=541 ? 'margin-bottom-2' : 'margin-bottom-4') +' relative'">
      <uni-blog-card-header
        [blog]="blog"
        [cardWidth]="cardWidth"
        [self]="self"
        [host]="host"
        [showCardOptions]="showCardOptions"
        (delete)="delete($event)"
        *ngIf="showHeader">
      </uni-blog-card-header>
    </div>

    <div fxLayout="row" [fxLayoutGap]="cardWidth <=541 ? '8px' : '20px'">
      <div fxLayout="column" class="imagebox">
        <ng-container *ngTemplateOutlet="image">
        </ng-container>
      </div>

      <div fxLayout="column" class="blog-card-content relative width-100 cursor-pointer" fxLayoutGap="8px">
        <div fxLayout="column" fxLayoutGap="8px">
          <ng-container
            *ngTemplateOutlet="title">
          </ng-container>
  
          <uni-blog-card-subtitle [class.fx-none]="cardWidth<=541"
            [blog]="blog"
            [cardWidth]="cardWidth">
          </uni-blog-card-subtitle>
        </div>

        <div class="width-100">
          <uni-blog-card-footer
            fxLayout="row wrap"
            [cardWidth]="cardWidth"
            fxLayoutAlign="start center"
            [blog]="blog"
            [self]="self"
            [host]="host">
          </uni-blog-card-footer>
        </div>
      </div>
    </div>
  </div>

  <div [ngClass]="{'blog-card-featured': !isDisplay, 'blog-card-feed-featured': isDisplay}" *ngIf="featured" #blogCardContainer>
    <div fxLayout="column" fxLayoutGap="20px">
      <uni-blog-card-header
        [blog]="blog"
        [cardWidth]="cardWidth"
        [self]="self"
        [host]="host"
        [showCardOptions]="showCardOptions"
        (delete)="delete($event)"
        *ngIf="showHeader">
      </uni-blog-card-header>

      <div [ngClass]="{'imagebox': !isDisplay, 'featuredimagebox': isDisplay}">
        <ng-container *ngTemplateOutlet="image">
        </ng-container>
      </div>
      
      <div fxLayout="column" fxLayoutGap="8px">
        <ng-container
          *ngTemplateOutlet="title">
        </ng-container>

        <uni-blog-card-subtitle
          [cardWidth]="cardWidth"
          [featured]="featured"
          [blog]="blog">
        </uni-blog-card-subtitle>
      </div>

      <uni-blog-card-footer
        fxLayout="row wrap"
        [cardWidth]="cardWidth"
        fxLayoutAlign="start center"
        [blog]="blog"
        [host]="host"
        [self]="self">
      </uni-blog-card-footer>
    </div>
  </div>
</ng-container>

<ng-template #noBlog>
</ng-template>

<ng-template #image>
  <uni-blog-card-image
    [blog]="blog"
    [cardWidth]="cardWidth"
    [featured]="featured"
    [self]="self"
    [host]="host"
    [isDisplay]="isDisplay"
    [dialogOpenable]="dialogOpenable"
    (openDialogEvent)="openDialog()"
    [host]="host">
  </uni-blog-card-image>
</ng-template>

<ng-template #title>
  <uni-blog-card-title
    [blog]="blog"
    [cardWidth]="cardWidth"
    [self]="self"
    [host]="host"
    (openDialogEvent)="openDialog()"
    [dialogOpenable]="dialogOpenable">
  </uni-blog-card-title>
</ng-template>
